import type { GeneratedLesson } from "../types";
import { BookOpen, Clock, Users } from "lucide-react";

interface LessonHeaderProps {
  lesson: GeneratedLesson;
}

export function LessonHeader({ lesson }: LessonHeaderProps) {
  return (
    <div
      className="p-4 sm:p-6 rounded-xl mb-6"
      style={{ backgroundColor: "var(--bg-accent)" }}
    >
      <div className="flex items-start justify-between mb-4 gap-4">
        <div className="min-w-0">
          <h2
            className="text-2xl sm:text-3xl font-bold mb-2 truncate"
            style={{ color: "var(--text-primary)" }}
          >
            {lesson.title || "Plano de Aula"}
          </h2>
          <p
            className="text-sm sm:text-base truncate"
            style={{ color: "var(--text-tertiary)" }}
          >
            {lesson.topic}
          </p>
        </div>
        <BookOpen
          className="w-10 h-10 sm:w-12 sm:h-12 opacity-10 shrink-0"
          style={{ color: "var(--primary-color)" }}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mt-6">
        <div className="flex items-center gap-2 bg-white/50 p-2 rounded-lg">
          <Clock
            className="w-4 h-4 shrink-0"
            style={{ color: "var(--primary-color)" }}
          />
          <span
            className="text-sm sm:text-base"
            style={{ color: "var(--text-secondary)" }}
          >
            {lesson.duration} minutos
          </span>
        </div>
        <div className="flex items-center gap-2 bg-white/50 p-2 rounded-lg">
          <Users
            className="w-4 h-4 shrink-0"
            style={{ color: "var(--primary-color)" }}
          />
          <span
            className="text-sm sm:text-base"
            style={{ color: "var(--text-secondary)" }}
          >
            {lesson.studentsCount} alunos
          </span>
        </div>
        <div
          className="px-3 py-2 rounded-lg text-center text-sm font-bold uppercase tracking-wider"
          style={{
            backgroundColor: "var(--primary-color)",
            color: "white",
          }}
        >
          {lesson.difficulty}
        </div>
      </div>
    </div>
  );
}
